import { render, staticRenderFns } from "./storage_movements.vue?vue&type=template&id=875d6bf8&scoped=true&"
import script from "./storage_movements.vue?vue&type=script&lang=js&"
export * from "./storage_movements.vue?vue&type=script&lang=js&"
import style0 from "./storage_movements.vue?vue&type=style&index=0&id=875d6bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875d6bf8",
  null
  
)

export default component.exports